import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomTable from "../../components/CustomTable";
import { faLocationDot, faUsersBetweenLines } from "@fortawesome/free-solid-svg-icons";
import "../CaseDetails/CaseDetails.css";
import { useState } from "react";
import TableComponent from "../../components/TableComponent";

function EndowmentsReport(params) {

    const columns = [
        { name: "اسم الوقف", key: "name" },
        { name: "تاريخ الصك", key: "date" },
        { name: "الحالة", key: "status_string" },
        { name: "النوع", key: "type" },
        { name: "إسم مسؤول الوقف", key: "empname" },
        { name: "", key: "actions" },
    ];

    const [rows, setRows] = useState([]);
    const [loading , setLoading] = useState(true);

//     const getEndowments = async () => {
//         try {
//             const res = await API.get("/endowments");
//             setRows(res.data);
//             setLoading(false);
//         } catch (error) {
//             console.log(error);
//         }
//     }
    const dropdownOptions = [
        { label: "تعديل", route: "/editEndowments/:id" },
    ];

// useEffect(() => {
//     getEndowments();
// }, []);
    const handleDownload = (selectedRows) => {
        const selectedData = rows.filter((row) => selectedRows.includes(row.id));
        if (selectedData.length === 0) {
            alert("Please select at least one row.");
            return;
        }

        const csvHeader = columns
            .filter((col) => col.key !== "actions")
            .map((col) => col.name)
            .join(",");

        const csvRows = selectedData.map((row) =>
            columns
                .filter((col) => col.key !== "actions")
                .map((col) => `"${row[col.key] || ""}"`)
                .join(",")
        );

        const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

        const bom = "\uFEFF";
        const finalContent = bom + csvContent;

        const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "selected_rows_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    

    return (
        <>
            <div className="printcasedata-container">

                {/* <CustomTable
                    title="تقرير الأوقاف"
                    titleIcon={<FontAwesomeIcon icon={faLocationDot} />}
                    columns={columns}
                    data={rows.map((row) => ({
                        id: row.id,
                        name: row.name,
                        endStatus: row.status == 0 ? 'فعال' : "غير فعال",
                        date: row.date,
                        type: row.type,
                        responsibleName: row.employee.name
                    }))}
                    onDownload={handleDownload}
                    dropdownOptions={dropdownOptions}
                    search={true}
                /> */}
                <TableComponent
                    apiUrl="/endowments"
                    columns={columns}
                    title="تقرير الأوقاف"
                    titleIcon={<FontAwesomeIcon icon={faLocationDot}/>}
                    dropdownOptions={dropdownOptions}
                />
            </div>
        </>
    );
}
export default EndowmentsReport
